import React, { useState } from "react";
import styled from "styled-components";
import { Button, H3, P } from "../../common";
import RichText from "../../../richText/RichText";
import { navigate } from "gatsby";
import { rejig2020Title } from "./Tile";

const Styled = {};
Styled.Tile = styled.button`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 10vh;
  position: relative;
  background: none;
  appearance: none;
  border: none;
  overflow: hidden;
  .content-div {
    z-index: 2;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem;
  }
  :hover {
    .overlay {
      transition: all 0.65s ease;
      opacity: 0.6;
    }
  }
  .overlay {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    flex-direction: flex-column;
    justify-content: center;
    z-index: 1;
    transition: all 0.65s ease;
  }
  .overlay {
    opacity: 0.3;
    background-color: black;
  }
  .thr-p {
    position: absolute;
    top: 200%;
    transition: all 0.74s ease;
    opacity: 0;
  }
  &.vanish {
    .thr-h3 {
      top: 0;
      opacity: 1;
      transition: all 0.5s ease;
    }
  }
  &.hovered {
    &.vanish {
      .thr-h3 {
        opacity: 0;
        top: -25%;
      }
    }
    .thr-p {
      transition: all 0.74s ease;
      top: 0;
      opacity: 1;
      position: relative;
    }
  }
  .thr-h3 {
    position: relative;
    transition: all 0.5s ease;
    top: -1vh;
  }
  &.hovered {
    .thr-h3 {
      transition: all 0.5s ease;
      top: 0vh;
    }
  }
`;

const HoverTile = ({ title, json, slug, vanish }) => {
  const [isActivated, setIsActivated] = useState(false);
  const handleStartHover = () => {
    setIsActivated(true);
  };
  const handleEndHover = () => {
    setIsActivated(false);
  };
  const handleClick = () => {
    navigate("/" + slug);
  };
  const classes = [];
  if (isActivated) classes.push("hovered");
  if (vanish) classes.push("vanish");
  return (
    <Styled.Tile
      onMouseEnter={handleStartHover}
      onMouseLeave={handleEndHover}
      className={classes.join(" ")}
      onClick={handleClick}
    >
      <div
        className="overlay"
        //isActivated={isActivated}
      />
      <div
        className="content-div"
        // isActivated={isActivated}
        // setIsActivated={setIsActivated}
      >
        <H3 white>{rejig2020Title(title)}</H3>
        {json && (
          <P white>
            <RichText json={json} />
          </P>
        )}
        <Button to={`/` + slug} white>
          Learn More
        </Button>
      </div>
    </Styled.Tile>
  );
};

export default HoverTile;
